import * as yup from 'yup';
import { OperationConf } from '../../operations/conf/Create.conf';
import _ from 'lodash';
import { API as servicesOperationList } from '../api/index';
import { API as marina } from '../../marina/api';

export const CommonFiels = [
  {
    id: 'yacht_divider',
    name: 'yacht_divider',
    type: 'divider',
    label: 'Yacht',
    xs: 12,
  },
  {
    id: 'yacht_name',
    name: 'yacht_name',
    type: 'text',
    label: 'Yacht',
    required: true,
    disabled: true,
    xs: 12,
  },
  {
    id: 'agent_NA_name',
    name: 'agent_NA_name',
    type: 'text',
    label: 'NA Agent',
    disabled: true,
    required: false,
    xs: 12,
  },
  {
    id: 'mexalValidation',
    name: 'mexalValidation',
    type: 'view-mexal-validation',
    xs: 12,
  },
];

const operationService = yup
  .object()
  .nullable()
  .required('Service is required');
const accountType = yup
  .object()
  .nullable()
  .required('Account type is required');

export const UpdateConf = {
  schema: yup.object({
    ..._.omit(OperationConf.schema, ['payment_type']),
    id_service: operationService,
    account_type: accountType,
  }),
  defaultValues: _.omit(OperationConf.defaultValues, ['payment_type']),
  fields: _.concat(
    CommonFiels,
    {
      id: 'service_generic',
      type: 'divider',
      label: 'Service',
      xs: 12,
    },
    {
      id: 'id_service',
      name: 'id_service',
      type: 'async_autocomplete',
      api: servicesOperationList.servicesOperationList,
      label: 'Service',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'id_marina',
      name: 'id_marina',
      type: 'async_autocomplete',
      label: 'Location',
      api: marina.select,
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'requested_date',
      name: 'requested_date',
      type: 'date',
      label: 'Delivery Date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'requested_hour',
      name: 'requested_hour',
      type: 'time',
      label: 'Delivery Time',
      required: false,
      xs: 12,
      sm: 6,
    },
    OperationConf.fields.slice(5, 17),
    OperationConf.fields.slice(18)
  ),
};
